import { isClient } from './application_helper';

export default class SessionStorageHelper {
  /**
   @param {string} key
   @param {String|*} item
   @param {date|*} expires
   */
  static setDataInSession(key, item, expires = null) {
    if (isClient()) {
      let wrappedItem;
      wrappedItem = {
        expires,
        item,
      };
      sessionStorage.setItem(key, JSON.stringify(wrappedItem));
    }
  }

  /**
   @param {string} key
   */
  static getDataFromSession(key) {
    let wrappedItem = null;
    let item = null;
    if (isClient()) {
      try {
        wrappedItem = JSON.parse(sessionStorage.getItem(key));
      } catch (e) {
        wrappedItem = null;
      }
      if (wrappedItem && (wrappedItem.expires === null || Date.parse(wrappedItem.expires) >= new Date())) {
        item = wrappedItem.item;
      } else {
        item = null;
      }
    }
    return item;
  }

  static deleteDataFromSession(key) {
    return sessionStorage.removeItem(key);
  }

  static clearAllData() {
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== 'fetchTraceId' && key !== 'enablePolly' && key !== 'pollyjs') {
        return sessionStorage.removeItem(key);
      }
    });
  }
}
